<template>
	<button
		:disabled="disabled"
		type="button"
		@click="handleUpload"
		:id="`upload_widget-${id}`"
		class="b360-btn--primary"
		:class="{ 'b360-btn--disabled': disabled }"
	>
		Upload
	</button>
</template>

<script>
export default {
	name: 'CloudinaryWidget',
	props: {
		id: String,
		disabled: Boolean,
		isLogo: Boolean,
	},
	created() {
		const scriptTag = document.createElement('script');
		scriptTag.src = 'https://widget.cloudinary.com/v2.0/global/all.js';
		scriptTag.id = `cloudinary-${this.id}`;
		document.getElementsByTagName('head')[0].appendChild(scriptTag);
	},
	methods: {
		handleUpload() {
			const preset = this.isLogo ? 'logo_preset' : 'cas_preset',
				croppingRatio = this.isLogo ? null : 1,
				transformation = this.isLogo
					? { width: 300, height: 300, crop: 'pad' }
					: {};

			// eslint-disable-next-line no-undef
			cloudinary.openUploadWidget(
				{
					cloudName: 'uwm',
					/**
					 * This api key is a public key and is not a security risk.
					 * We are using this as cloudinary advises.
					 */
					// file deepcode ignore HardcodedNonCryptoSecret: <please see above comment>
					apiKey: '767347319899842',
					showPoweredBy: false,
					styles: {
						palette: {
							window: '#EAF7FF',
							sourceBg: '#FFFFFF',
							windowBorder: '#005F9E',
							tabIcon: '#005F9E',
							inactiveTabIcon: '#69778A',
							menuIcons: '#005F9E',
							link: '#005F9E',
							action: '#005F9E',
							inProgress: '#0194c7',
							complete: '#009396',
							error: '#E01A1A',
							textDark: '#111111',
							textLight: '#FFFFFF',
						},
						fonts: {
							default: null,
							"font-family: 'Roboto', sans-serif": {
								url: 'https://fonts.googleapis.com/css?family=Roboto&display=swap',
								active: true,
							},
						},
					},
					uploadPreset: preset,
					cropping: true,
					thumbnailTransformation: transformation,
					croppingAspectRatio: croppingRatio,
					multiple: false,
					clientAllowedFormats: ['jpg', 'jpeg', 'png', 'gif', 'svg'],
					maxImageFileSize: 20000000, // 20 MB,
					showSkipCropButton: true,
					text: {
						en: {
							crop: {
								title:
									'Please crop your image into a 1:1 ratio (square). This image will be used in marketing materials.',
							},
						},
					},
					preBatch: (cb, data) => {
						let width = null,
							height = null;
						if (data.files[0] && data.files[0].customCoordinates) {
							width = data.files[0].customCoordinates.width;
							height = data.files[0].customCoordinates.height;
						}

						// if not a square for profile photos cancel the upload
						if (!data.files[0].customCoordinates) {
							window.confirm(
								`Your image must be a 1:1 square ratio in order to appear properly on marketing materials. Proceed?`,
							)
								? cb()
								: cb({ cancel: true });
						}

						// if the file exists and the width or the height is less than 300px
						else if (width !== null && (width < 300 || height < 300)) {
							// send the user a dialog to confirm if they would like to proceed
							window.confirm(
								`Image (${width}x${height}) does not meet quality standards (300x300) and may appear distorted on marketing materials. \rAre you sure you would like to proceed?`,
							)
								? cb()
								: cb({ cancel: true });
						} else {
							cb();
						}
					},
				},
				(error, result) => {
					if (!error && result && result.event === 'success') {
						const resultInfo = result.info;
						const { width, height } = resultInfo;
						const newUrl = (arr, url) => {
							arr.splice(1, 0, url);
							return arr.join('');
						};

						if (this.isLogo || width !== height) {
							resultInfo['secure_url'] = newUrl(
								resultInfo['secure_url'].split('upload'),
								'upload/w_300,h_300,c_pad,b_white',
							);
						}

						this.$emit('handle-upload', resultInfo);
					}
				},
			);
		},
	},
};
</script>
